module.exports = __webpack_public_path__ + "MG.png?852e7a321cbd1f12787e5081a0ac9ce3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/MG.png
// module id = 380
// module chunks = 0